import { defineMessages } from 'react-intl';

const messages = defineMessages({
  home: {
    id: 'Navigation.Home',
    defaultMessage: 'Home',
  },
  brands: {
    id: 'Navigation.Brands',
    defaultMessage: 'Brands',
  },
  categories: {
    id: 'Navigation.Categories',
    defaultMessage: 'Categories',
  },
  search: {
    id: 'Navigation.Search',
    defaultMessage: 'Search',
  },
});

export default messages;
